import React, { useEffect } from "react";
import { Box, CircularProgress } from "@material-ui/core";
import { DetailsCard, Typography } from "@welldigital/components";
import PageLayout from "../../layouts/PageLayout";
import { getCardsData } from "./cardsData";
import { useStyles } from "./useStyles";
import { useAuthentication } from "@welldigital/ui-common/Authentication/components/AuthenticationProvider";
import { doRedirect } from "@welldigital/ui-common/Utils/navigation";
import { signUpTargets } from "../../envDerivedConstants";
const signUpTargetsArray = Object.values(signUpTargets);

const SignUpTargets = (): JSX.Element => {
  const { availableLinks } = useAuthentication();
  const classes = useStyles();
  const cardsData = getCardsData(classes, availableLinks);
  const cardsDataEntries = [...Object.entries(cardsData)];

  useEffect(() => {
    if (signUpTargetsArray.length === 1) {
      doRedirect(signUpTargetsArray[0]);
    }
  }, []);

  if (signUpTargetsArray.length === 1) {
    return (
      <Box display={"flex"} justifyContent={"center"} pt={2}>
        <CircularProgress size={40} />
      </Box>
    );
  }

  return (
    <PageLayout withUserProfile>
      <div>
        <Typography className={classes.pageTitle}>
          Which service do you want to create an account for?
        </Typography>
        <Box className={classes.detailCardsWrapper}>
          {cardsDataEntries.map(([key, data]) => {
            return (
              <DetailsCard
                key={key}
                {...data.cardProps}
                className={classes.detailsCard}
              >
                {data.content}
              </DetailsCard>
            );
          })}
        </Box>
      </div>
    </PageLayout>
  );
};

export default SignUpTargets;
